export default function Footer() {
  return (
    <footer className="app-footer">
      <div className="wrap">
        <p>
          LBI Local — Barnegat Light to Holgate. An independent guide to Long Beach Island, New
          Jersey.
        </p>
        <p className="muted">© {new Date().getFullYear()} LBI Local</p>
      </div>
    </footer>
  );
}
